import RuleCondition from './src/main';

/* istanbul ignore next */
RuleCondition.install = function(Vue) {
  Vue.component(RuleCondition.name, RuleCondition);
};

export default RuleCondition;
